import { render, staticRenderFns } from "./searchMaterial.vue?vue&type=template&id=00acdf68&"
import script from "./searchMaterial.vue?vue&type=script&lang=js&"
export * from "./searchMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports